import {
  SWITCH_LANGUAGE,
  TOGGLE_COLLAPSED_NAV,
  TOGGLE_COLLAPSED_LANG,
  TOGGLE_COLLAPSED_MEMBER_MENU,
  COLLAPSED_ALL_MENU,
  SET_MENU_FOOTER_ACTIVE
} from "../actions/types";

if (!localStorage.getItem("app-lang")) {
  localStorage.setItem(
    "app-lang",
    JSON.stringify({
      languageId: "thai",
      locale: "th",
      name: "Thai",
      icon: "th",
    })
  );
}
let localStorageLang = localStorage.getItem("app-lang");
localStorageLang = JSON.parse(localStorageLang);
const INIT_STATE = {
  locale: localStorageLang,
  navCollapsed: false,
  langCollapsed: false,
  memberMenuCollapsed: false,
  menuFooterActive: 0,
};

export default (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case SWITCH_LANGUAGE:
      localStorage.setItem("app-lang", JSON.stringify(action.payload));
      return {
        ...state,
        locale: action.payload,
      };
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: !state.navCollapsed,
      };
    case TOGGLE_COLLAPSED_LANG:
      if (action.payload === true) {
        return {
          ...state,
          navCollapsed: false,
          langCollapsed: true,
          insuranceCollapsed: false,
          hotInsuranceCollapsed: false,
          allInsuranceCollapsed: false,
          memberMenuCollapsed: false,
        };
      } else {
        return {
          ...state,
          langCollapsed: action.payload,
        };
      }
    case TOGGLE_COLLAPSED_MEMBER_MENU:
      return {
        ...state,
        memberMenuCollapsed: !state.memberMenuCollapsed,
      };
    case SET_MENU_FOOTER_ACTIVE:
      return {
        ...state,
        menuFooterActive: action.payload,
      };
    case COLLAPSED_ALL_MENU:
      return {
        ...state,
        navCollapsed: false,
        langCollapsed: false,
        insuranceCollapsed: false,
        hotInsuranceCollapsed: false,
        allInsuranceCollapsed: false,
        memberMenuCollapsed: false,
      };
    default:
      return state;
  }
};
